// extracted by mini-css-extract-plugin
export var bubble = "_1d-0";
export var container = "_1d-f";
export var contrastBorder = "_1d-g";
export var greyOut = "_1d-2";
export var initialsColor0 = "_1d-3";
export var initialsColor1 = "_1d-4";
export var initialsColor10 = "_1d-d";
export var initialsColor11 = "_1d-e";
export var initialsColor2 = "_1d-5";
export var initialsColor3 = "_1d-6";
export var initialsColor4 = "_1d-7";
export var initialsColor5 = "_1d-8";
export var initialsColor6 = "_1d-9";
export var initialsColor7 = "_1d-a";
export var initialsColor8 = "_1d-b";
export var initialsColor9 = "_1d-c";
export var initialsWrapper = "_1d-1";
export var large = "_1d-l";
export var medium = "_1d-k";
export var mediumSmall = "_1d-j";
export var mediumSmallMedium = "_1d-o";
export var micro = "_1d-h";
export var small = "_1d-i";
export var tiny = "_1d-n";
export var xTiny = "_1d-m";